import api from '../api/axios';

const BASE = '/v1/usuarios/me';

export function useProfile() {
  const getMiPerfil = () => api.get(`${BASE}/`);
  
  const updateMiPerfil = (data) => api.patch(`${BASE}/`, data);
  
  const cambiarPassword = (data) => api.post(`${BASE}/cambiar-password/`, data);

  return {
    getMiPerfil, updateMiPerfil, cambiarPassword,
  };
}
